<template>
  <ProductPopupGallery v-if="show_popup_gallery"/>
  <Breadcrumbs/>
  <router-view :key="$route.fullPath"/>
</template>

<script>
import Breadcrumbs from "./components/Breadcrumbs";
import ProductPopupGallery from "./components/ForProductCard/ProductPopupGallery";

export default {
  name: "Pubcatalog",
  components: {
    Breadcrumbs,
    ProductPopupGallery,
  },
  data() {
    return {
      show_popup_gallery:false,
    }
  },
  updated() {
    this.show_popup_gallery = this.$route.name != 'group';
  }
}
</script>